module.exports = __webpack_public_path__ + "static/img/wawa4.0b86495.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wawa4.png
// module id = GFek
// module chunks = 2